<template>
    <div class="d-flex flex-column sponsor-panel" v-if="competitivePart != null">
        <div class="d-flex justify-content-between flex-grow-0 sponsor-heading pl-1">
            <div>Alternative Part</div>
            <div class="sponsored d-flex align-items-center justify-content-center pl-2 pr-2">
                Sponsored
            </div>
        </div>
        <div class="d-flex justify-content-between flex-grow-1 pl-2 pr-2">
            <div class="d-flex flex-column align-items-center justify-content-center pl-2 pr-2 flex-shrink-0">
                <div>{{competitivePart.manufacturerName}}</div>
                <router-link class="competitive-part-link internal" @click="competitiveClick" :to="`/${$store.state.instance}/part/p/${competitivePart.partUniqueId}/ref/${competitivePart.referrerTag}/t/${competitivePart.term}`">{{competitivePart.manufacturerPartNumber}}</router-link>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center pl-2 pr-2 flex-grow-1">
                <div class="sponsor-description">
                    {{competitivePart.relationshipTypeLabel}}
                </div>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center pl-2 pr-2 flex-shrink-0" v-if="competitivePart.hasExternalLink == true">
                <a @click="externalClick" v-bind:class="competitivePart.advertiserItem.advertiserExternalLinkClass">
                    <span class="advertiser-competitive-part-link-external-image" v-bind:class="competitivePart.externalPartLinkCssClass"></span>
                    <span class="advertiser-competitive-part-link-external-text">{{competitivePart.externalPartLinkText}}</span>
                    <span class="advertiser-competitive-part-link-external-spacer"></span>
                </a>
            </div>
            <div class="d-flex model-availability-listing align-items-center justify-content-center pl-2 pr-2 flex-shrink-0">
                <div v-bind:class="[competitivePart.hasSymbol ? 'model-availability-symbol-active' : 'model-availability-symbol-inactive']"></div>
                <div v-bind:class="[competitivePart.hasFootprint ? 'model-availability-footprint-active' : 'model-availability-footprint-inactive']"></div>
                <div v-bind:class="[competitivePart.has3D ? 'model-availability-threed-active' : 'model-availability-threed-inactive']"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CompetitivePartPanel',
        props: {
            competitivePart: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            partContent: {
                type: Object,
                default: () => {
                    return null
                }
            }
        },
        methods: {
            competitiveImpression: function () {
                this.$store.dispatch('gtmCompetitivePart', { sourceMfrName: this.partContent.manufacturer, sourceMfrPN: this.partContent.partNumber, mfrName: this.competitivePart.manufacturer, mfrPN: this.competitivePart.partNumber, advertiser: this.competitivePart.advertiserName });
            },
            competitiveClick: function () {
                this.$store.dispatch('gtmCompetitiveInternal', { sourceMfrName: this.partContent.manufacturer, sourceMfrPN: this.partContent.partNumber, mfrName: this.competitivePart.manufacturer, mfrPN: this.competitivePart.partNumber, advertiser: this.competitivePart.advertiserName });
            },
            externalClick: function () {
                this.$store.dispatch('gtmCompetitiveExternal', { sourceMfrName: this.partContent.manufacturer, sourceMfrPN: this.partContent.partNumber, mfrName: this.competitivePart.manufacturer, mfrPN: this.competitivePart.partNumber, advertiser: this.competitivePart.advertiserName });
                this.$store.dispatch('openUrl', { url: this.competitivePart.externalPartLink });
            }
        },
        async mounted() {
            if (this.competitivePart != null)
                this.competitiveImpression();
        }
    }
</script>

<style scoped>
</style>